import {APIClient} from '../backend/ApiClient';
import {useQuery} from 'react-query';
import {useContext} from 'react';
import {AuthContext} from '../context/AuthContext';
import {config} from '../init/config';

export const useGetDisclaimerData = () => {
    const {isAuthenticated} = useContext(AuthContext);
    const apiClient = APIClient();

    return useQuery(
        [],
        () => apiClient.getDisclaimerData(),
        {
            retry: 1,
            enabled: config.DLS_AUTHENTICATION_ACTIVE ? isAuthenticated : true
        }
    );
};
